<div class="phx-banner-box">
  <div class="phx-banner-left">
    <p *ngIf="!!phxTitle" class="phx-banner-title">{{ phxTitle }}<span>:</span></p>
    <ng-content></ng-content>
  </div>
  <button phx-icon-button phxIconButtonSize="small" *ngIf="phxShowNextIcon" (click)="onNextClick()" [phxIcon]="ArrowRightIcon" class="phx-banner-icon-button"></button>
</div>
